export const PACKAGE_NAME = "navbarx";